/**
 * Reduces a stored fax/phone value to the 10-digit national number the
 * "(999) 999-9999" input mask expects.
 *
 * Provider data arrives in many shapes ("+15853404070", "614.349.4447",
 * "216-472-2693", " 6098906422"). The mask consumes digits left to right and
 * silently drops everything after the tenth, so "+15853404070" would be
 * presented as "(158) 534-0407". Returns '' when the value cannot be reduced
 * to exactly 10 digits so the required validator makes the user type it.
 */
export function toTenDigitFaxNumber(value: string | null | undefined): string {
  const digits = (value ?? '').replace(/\D/g, '');
  const national = digits.length === 11 && digits.startsWith('1') ? digits.substring(1) : digits;
  return national.length === 10 ? national : '';
}
